import { useNavigate } from 'react-router-dom';
import eiqIconOrange from 'assets/icons/eiq-icon-orange.png';
import './payease-header.scss';

interface IPayEaseHeaderProps {
  communityName?: string | null;
}

export const PayEaseHeader = ({ communityName }: IPayEaseHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className="payease-header">
      <div className="payease-header__inner">
        <div className="payease-header__brand">
          <img className="payease-header__logo" src={eiqIconOrange} alt="EntranceIQ" />
          <div className="payease-header__brand-text">
            <p className="payease-header__eyebrow">EntranceIQ</p>
            <h1 className="payease-header__title">PayEase POS Terminal</h1>
          </div>
        </div>
        <div className="payease-header__side">
          {communityName && (
            <div className="payease-header__community">
              <p className="payease-header__eyebrow">Community</p>
              <p className="payease-header__community-name">{communityName}</p>
            </div>
          )}
          <button className="payease-header__back" type="button" onClick={() => navigate('/eiq-secure')}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={16}
              height={16}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true">
              <path d="m12 19-7-7 7-7" />
              <path d="M19 12H5" />
            </svg>
            Back to EIQ-Secure
          </button>
        </div>
      </div>
    </header>
  );
};
